import React from "react";
import { Card, Container, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import { ReactComponent as ProfileIcon } from "../Assets/Icons/profileIcon.svg";
import { ReactComponent as DeleteIcon } from "../Assets/Icons/deleteIcon.svg";
import { ReactComponent as PasswordIcon } from "../Assets/Icons/passwordIcon.svg";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import { ToastContainer, toast } from "react-toastify";

export default function AdminPasswordRequest() {
  const notify = () => toast.info("E-mail sent! Please check your e-mail");
  return (
    <Container fluid>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PageLayout>
        <div>
          <h1 className="admin-profile-setting-heading">Settings</h1>
          <div className="profile-detail-parent">
            <Card
              style={{ width: "fit-content" }}
              className="profile-seetting-card"
            >
              <div className="admin-setting-list-con">
                <div className="admin-setting-list">
                  <ProfileIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Profile</p>
                </div>
                <div className="admin-setting-list">
                  <PasswordIcon style={{ width: "1.5rem" }} fill="black" />
                  <p style={{ color: "black", fontWeight: "700" }}>Password</p>
                </div>
                <div className="admin-setting-list">
                  <DeleteIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Delete Account</p>
                </div>
              </div>
            </Card>
            <Card
              style={{ paddingBottom: "4rem" }}
              className="profile-seetting-card"
            >
              <div className="profile-seeting-sec-one">
                <div className="profile-setting-profile">
                  <img src={ProfileImg} />
                  <p>Admin Name</p>
                </div>
                <Button onClick={notify} style={{ width: "fit-content" }}>
                  Request new password
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
